import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Standalone sign-out page — not wrapped in any auth guard.
 *
 * Visited when a user logs out from a urlslug subdomain (e.g. acme.databull.ai)
 * and we need to also clear the stale session stored in app.databull.ai's
 * localStorage, preventing it from auto-redirecting back to the urlslug domain
 * on the next visit.
 *
 * Uses scope:'local' because the server-side refresh token was already revoked
 * by the global signOut called on the urlslug domain.
 */
const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.signOut({ scope: "local" }).finally(() => {
      navigate("/auth", { replace: true });
    });
  }, []);

  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      Signing out…
    </div>
  );
};

export default SignOut;
